import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenant = (
    token, 
    FullName, 
    ShortName, 
    Type, 
    Active, 
    Live, 
    BusinessStatus, 
    BusinessComment,
    PrimaryContact,
    SecondaryContact
) => {
    return fetch(`${apiUrl}tenants`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            FullName,
            ShortName,
            Type,
            Active,
            Live,
            BusinessStatus,
            BusinessComment,
            PrimaryContact,
            SecondaryContact
        })
    });
}

export default postTenant